import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { trackPageVisit } from '../services/visitTrackingService';

/**
 * Hook pour tracker automatiquement les visites de pages
 * OPTIMISÉ : Récupère le rôle depuis le contexte pour éviter une requête DB
 */
export const usePageTracking = (pageTitle) => {
  const location = useLocation();
  const { user, userProfile } = useAuth();
  
  useEffect(() => {
    // Track la visite immédiatement (fire-and-forget, non bloquant)
    trackPageVisit(
      location.pathname + location.search,
      pageTitle,
      user?.id || null,
      userProfile?.role || null
    );
  }, [location.pathname, location.search, pageTitle, user?.id, userProfile?.role]);
};
